
import { IRoleOptionsItem } from '../../types/common';
import { IAddServerUser, IServerParam, IServerUser } from '../../types/user-center/server';
import { EAxiosResponseCode, getHttpErrorMessage, Http } from '@core/api';
import { getHostbaseUrl } from '@core/tools';

const hostUrl = getHostbaseUrl();

/**
 * 用户中心 - 服务商用户数据查询
 */
export async function queryServerUsers(param: IServerParam) {
  let data = [] as IServerUser[];
  let total = 0;

  param = JSON.parse(JSON.stringify(param)) as IServerParam;

  try {
    const { code, context, message } = await Http.post<{ data: IServerUser[]; total: number }>(`${hostUrl}/iam/identity/server/list`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const { data: items, total: all } = context || {} as { data: IServerUser[]; total: number };

      data = items || [];
      total = all || 0;
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return {
    data,
    total,
  };
}
/**
 * 用户中心 - 服务商用户 - 角色列表
 */
export async function queryServerRoleList(serverId?: number, isDisplay?: boolean) {
  let data = [] as IRoleOptionsItem[];

  try {
    const { code, context, message } = await Http.post<Array<IRoleOptionsItem>>(`${hostUrl}/iam/role/server/list`, {
      serverId,
      isDisplay,
    });

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || [];

      data = res || [];
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}

/**
 * 用户中心 - 服务商用户 - 新增用户
 */
export async function addServerUsers(param: IAddServerUser) {
  let data = {} as { warnCode: number; extra: { name: string }};

  try {
    const { code, context, message } = await Http.post<any>(`${hostUrl}/iam/identity/server`, param);

    if (code === EAxiosResponseCode.Succeed) {
      const res = context || {};

      data = res || {};
    } else {
      throw new Error(message || '服务器异常，请稍后再试~');
    }
  } catch (error) {
    throw new Error(getHttpErrorMessage(error));
  }

  return { data };
}
